import React, { createContext, useContext, useState, useEffect } from "react";

const dict = {
  pt: {
    nav: {
      home: "Home",
      services: "Serviços",
      solutions: "Soluções SAP",
      about: "Sobre",
      contact: "Contato",
      cta: "Fale com um especialista",
    },
    hero: {
      tag: "SAP · BUSINESS INTELLIGENCE · DATA ENGINEERING",
      title_a: "Dados além do cálculo.",
      title_b: "Decisões além do óbvio.",
      sub: "A BEYONDCALCULUS desenha arquiteturas SAP e plataformas de Business Intelligence que transformam dados corporativos em vantagem competitiva mensurável.",
      cta_primary: "Iniciar projeto",
      cta_secondary: "Ver soluções",
      stats: [
        { value: "20+", label: "anos em SAP" },
        { value: "60%", label: "mais rápido em reporting" },
        { value: "3x", label: "ROI médio em BI" },
        { value: "70+", label: "projetos entregues" },
      ],
    },
    services: {
      eyebrow: "O QUE FAZEMOS",
      title: "Soluções end-to-end em SAP & BI",
      sub: "Cobrimos toda a jornada do dado — da fonte transacional ao insight executivo — com tecnologias de referência do ecossistema SAP.",
      items: [
        { code: "01", title: "SAP BW/4HANA", desc: "Arquitetura de data warehouse de alta performance, modelagem LSA++ e migração de BW clássico.", tags: ["DW", "ETL", "HANA"] },
        { code: "02", title: "SAP Analytics Cloud", desc: "Planejamento, predições e dashboards executivos integrados em tempo real ao backend SAP.", tags: ["Planning", "Dashboards", "AI"] },
        { code: "03", title: "SAP Datasphere", desc: "Camada de business data fabric unificando S/4HANA, fontes não-SAP e dados em nuvem com governança.", tags: ["Data Fabric", "Cloud"] },
        { code: "04", title: "Implementação S/4HANA", desc: "Roll-outs, conversões brownfield e otimização de processos com metodologia SAP Activate.", tags: ["S/4HANA", "Activate"] },
        { code: "05", title: "Consultoria BI", desc: "Estratégia de dados, KPIs corporativos, data governance e enablement de squads analíticos.", tags: ["Strategy", "KPI"] },
        { code: "06", title: "Dashboards & KPIs", desc: "Painéis self-service em SAC, Power BI e Tableau conectados nativamente ao seu landscape SAP.", tags: ["SAC", "PowerBI"] },
      ],
    },
    method: {
      eyebrow: "METODOLOGIA",
      title: "Como entregamos valor.",
      steps: [
        { n: "01", t: "Discovery", d: "Imersão no negócio, mapeamento de fontes SAP/não-SAP e definição de KPIs prioritários." },
        { n: "02", t: "Arquitetura", d: "Desenho da plataforma de dados — modelagem, segurança, governança e roadmap incremental." },
        { n: "03", t: "Build", d: "Desenvolvimento em squads ágeis com entregas quinzenais e validação de negócio contínua." },
        { n: "04", t: "Run & Scale", d: "Sustentação evolutiva, monitoramento de SLAs e enablement do time interno do cliente." },
      ],
    },
    cases: {
      eyebrow: "RESULTADOS",
      title: "Métricas que importam.",
      items: [
        { metric: "−60%", label: "tempo de fechamento contábil", desc: "Indústria · Migração BW → BW/4HANA com modelagem otimizada." },
        { metric: "+3x", label: "ROI em 18 meses", desc: "Varejo · Plataforma SAC com forecast e planejamento integrado." },
        { metric: "99.95%", label: "disponibilidade do landscape", desc: "Energia · Sustentação 24/7 de S/4HANA + BW/4HANA." },
      ],
    },
    about: {
      eyebrow: "QUEM SOMOS",
      title: "Engenharia de dados com obsessão por precisão.",
      body: "Somos um time enxuto de arquitetos SAP e engenheiros de BI sêniores. Combinamos rigor de engenharia com pensamento de produto — para entregar plataformas de dados que sobrevivem ao próximo redesign de negócio.",
      bullets: [
        "Especialistas certificados SAP (BW, HANA, S/4)",
        "Squads multidisciplinares com PO de negócio",
        "Práticas DataOps, CI/CD para SAP e versionamento",
        "Foco em adoção: enablement do cliente desde o dia 1",
      ],
    },
    contact: {
      eyebrow: "VAMOS CONVERSAR",
      title: "Pronto para ir além do cálculo?",
      sub: "Conte seu desafio. Em até 1 dia útil retornamos com uma proposta de discovery.",
      name: "Nome",
      email: "E-mail corporativo",
      company: "Empresa",
      message: "Descreva seu desafio",
      send: "Enviar mensagem",
      sent: "Recebido! Em breve um especialista entrará em contato.",
    },
    footer: {
      tagline: "Dados além do cálculo.",
      rights: "Todos os direitos reservados.",
    },
    chat: {
      title: "Assistente BEYONDCALCULUS",
      sub: "Tire dúvidas sobre SAP & BI",
      placeholder: "Pergunte sobre SAP, BW/4HANA, SAC...",
      send: "Enviar",
      greeting: "Olá! Sou o assistente da BEYONDCALCULUS. Posso ajudar com SAP BW/4HANA, Analytics Cloud, Datasphere, S/4HANA ou BI em geral. O que você quer saber?",
      thinking: "Pensando...",
      error: "Ops, algo deu errado. Tente novamente.",
    },
  },
  en: {
    nav: {
      home: "Home",
      services: "Services",
      solutions: "SAP Solutions",
      about: "About",
      contact: "Contact",
      cta: "Talk to a specialist",
    },
    hero: {
      tag: "SAP · BUSINESS INTELLIGENCE · DATA ENGINEERING",
      title_a: "Beyond the calculus.",
      title_b: "Beyond the obvious decisions.",
      sub: "BEYONDCALCULUS designs SAP architectures and Business Intelligence platforms that turn enterprise data into measurable competitive advantage.",
      cta_primary: "Start a project",
      cta_secondary: "Explore solutions",
      stats: [
        { value: "20+", label: "years in SAP" },
        { value: "60%", label: "faster reporting" },
        { value: "3x", label: "average BI ROI" },
        { value: "70+", label: "projects delivered" },
      ],
    },
    services: {
      eyebrow: "WHAT WE DO",
      title: "End-to-end SAP & BI solutions",
      sub: "We cover the full data journey — from transactional source to executive insight — with the SAP reference stack.",
      items: [
        { code: "01", title: "SAP BW/4HANA", desc: "High-performance data warehouse architecture, LSA++ modeling and legacy BW migration.", tags: ["DW", "ETL", "HANA"] },
        { code: "02", title: "SAP Analytics Cloud", desc: "Planning, predictions and executive dashboards integrated live with your SAP backend.", tags: ["Planning", "Dashboards", "AI"] },
        { code: "03", title: "SAP Datasphere", desc: "Business data fabric unifying S/4HANA, non-SAP sources and cloud data with governance.", tags: ["Data Fabric", "Cloud"] },
        { code: "04", title: "S/4HANA Implementation", desc: "Roll-outs, brownfield conversions and process optimization with SAP Activate methodology.", tags: ["S/4HANA", "Activate"] },
        { code: "05", title: "BI Consulting", desc: "Data strategy, corporate KPIs, data governance and enablement of analytics squads.", tags: ["Strategy", "KPI"] },
        { code: "06", title: "Dashboards & KPIs", desc: "Self-service dashboards in SAC, Power BI and Tableau natively connected to your SAP landscape.", tags: ["SAC", "PowerBI"] },
      ],
    },
    method: {
      eyebrow: "METHODOLOGY",
      title: "How we deliver value.",
      steps: [
        { n: "01", t: "Discovery", d: "Business immersion, SAP/non-SAP source mapping and prioritization of key KPIs." },
        { n: "02", t: "Architecture", d: "Data platform design — modeling, security, governance and incremental roadmap." },
        { n: "03", t: "Build", d: "Agile squads with bi-weekly releases and continuous business validation." },
        { n: "04", t: "Run & Scale", d: "Evolutionary support, SLA monitoring and client team enablement." },
      ],
    },
    cases: {
      eyebrow: "RESULTS",
      title: "Metrics that matter.",
      items: [
        { metric: "−60%", label: "accounting close time", desc: "Manufacturing · BW → BW/4HANA migration with optimized modeling." },
        { metric: "+3x", label: "ROI in 18 months", desc: "Retail · SAC platform with integrated planning & forecast." },
        { metric: "99.95%", label: "landscape uptime", desc: "Energy · 24/7 support for S/4HANA + BW/4HANA." },
      ],
    },
    about: {
      eyebrow: "WHO WE ARE",
      title: "Data engineering obsessed with precision.",
      body: "We are a lean team of senior SAP architects and BI engineers. We combine engineering rigor with product thinking — to deliver data platforms that survive the next business redesign.",
      bullets: [
        "SAP certified specialists (BW, HANA, S/4)",
        "Cross-functional squads with business PO",
        "DataOps, CI/CD for SAP and versioning",
        "Adoption-first: client enablement from day one",
      ],
    },
    contact: {
      eyebrow: "LET'S TALK",
      title: "Ready to go beyond the calculus?",
      sub: "Tell us your challenge. Within 1 business day we'll respond with a discovery proposal.",
      name: "Name",
      email: "Corporate email",
      company: "Company",
      message: "Describe your challenge",
      send: "Send message",
      sent: "Received! A specialist will contact you soon.",
    },
    footer: {
      tagline: "Beyond the calculus.",
      rights: "All rights reserved.",
    },
    chat: {
      title: "BEYONDCALCULUS Assistant",
      sub: "Ask about SAP & BI",
      placeholder: "Ask about SAP, BW/4HANA, SAC...",
      send: "Send",
      greeting: "Hi! I'm the BEYONDCALCULUS assistant. I can help with SAP BW/4HANA, Analytics Cloud, Datasphere, S/4HANA or BI in general. What would you like to know?",
      thinking: "Thinking...",
      error: "Oops, something went wrong. Please try again.",
    },
  },
};

const I18nContext = createContext({ lang: "pt", setLang: () => {}, t: dict.pt });

export const I18nProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("bc_lang") || "pt");
  useEffect(() => {
    localStorage.setItem("bc_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);
  const value = { lang, setLang, t: dict[lang] };
  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
};

export const useI18n = () => useContext(I18nContext);
